module.exports = __webpack_public_path__ + "static/img/product-brand-active.5b02b61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/product-brand-active.png
// module id = I1r0
// module chunks = 26